import { render, staticRenderFns } from "./NewThesisForm.vue?vue&type=template&id=1b20f12f"
import script from "./NewThesisForm.vue?vue&type=script&lang=js"
export * from "./NewThesisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports